import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class OpenDisputeSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'date',
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'date',
    },
    {
      label: 'label.arLevel',
      name: 'arLevel',
      tOptions: 'selections:arLevel',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.taxTreatment',
      name: 'taxTreatment',
      type: 'select',
      tOptions: 'selections:taxRule',
      isClearable: true,
    },
    {
      label: 'label.arThreshold',
      name: 'arThreshold',
      type: 'number',
    },
    {
      label: 'label.accountType',
      name: 'accountType',
      type: 'select',
      tOptions: 'selections:accountType',
      isClearable: true,
    },
    {
      label: 'label.paymentMethod',
      name: 'paymentMethod',
      tOptions: 'selections:paymentMethod',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.reason',
      name: 'reason',
      tOptions: 'selections:reasonConfig',
      isClearable: true,
      type: 'select',
    },
  ];

  btnSpan = 'col-md-12';
}

OpenDisputeSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

OpenDisputeSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(OpenDisputeSearchForm);
